// @ts-nocheck
import { Box } from '@mui/material';
import { DotsSixVertical, PencilSimple } from '@phosphor-icons/react';
import DeleteButton from '../../Layout/DeleteButton/DeleteButton';
import * as PropTypes from 'prop-types';
import './CollectionRoundCard.css';

const CollectionRoundCard = ({
  round,
  isActive = false,
  onClick,
  dragHandleProps = null,
  isStatic = false,
  showEditAction = true,
  onEdit,
  showDeleteAction = true,
  onDelete
}) => {
  return (
    <div
      className={[
        'passenger-collection-panel__round-card',
        isStatic && 'passenger-collection-panel__round-card--static',
        isActive && 'passenger-collection-panel__round-card--active'
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
    >
      <Box className='passenger-collection-panel__round-main'>
        <Box className='passenger-collection-panel__round-name-group'>
          <Box
            className={[
              'passenger-collection-panel__drag-handle',
              dragHandleProps &&
                'passenger-collection-panel__drag-handle--enabled',
              !dragHandleProps &&
                isStatic &&
                'passenger-collection-panel__drag-handle--static'
            ]
              .filter(Boolean)
              .join(' ')}
            {...(dragHandleProps ?? {})}
            onClick={(event) => event.stopPropagation()}
          >
            {dragHandleProps && !isStatic && <DotsSixVertical size={18} />}
          </Box>

          <Box className='passenger-collection-panel__round-copy'>
            <Box className='passenger-collection-panel__round-title-row'>
              <span className='passenger-collection-panel__round-name'>
                {round?.name}
              </span>
              <span className='passenger-collection-panel__count-badge'>
                {round?.fieldcount ?? 0}
              </span>
            </Box>
            <span className='passenger-collection-panel__round-subtitle'>
              {round?.subtitle}
            </span>
          </Box>
        </Box>

        <Box
          component='div'
          className='passenger-collection-panel__round-actions'
          onClick={(event) => event.stopPropagation()}
        >
          {showEditAction ? (
            <Box
              component='button'
              type='button'
              className='passenger-collection-panel__round-action passenger-collection-panel__round-action--edit'
              onClick={(event) => {
                event.stopPropagation();
                onEdit?.();
              }}
            >
              <PencilSimple size={18} />
            </Box>
          ) : null}
          {showDeleteAction ? (
            <DeleteButton size={18} onClick={onDelete} />
          ) : (
            <Box className='passenger-collection-panel__round-action-placeholder' />
          )}
        </Box>
      </Box>
    </div>
  );
};

CollectionRoundCard.propTypes = {
  round: PropTypes.shape({
    name: PropTypes.string,
    subtitle: PropTypes.string,
    fieldcount: PropTypes.number
  }),
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  dragHandleProps: PropTypes.object,
  isStatic: PropTypes.bool,
  showEditAction: PropTypes.bool,
  onEdit: PropTypes.func,
  showDeleteAction: PropTypes.bool,
  onDelete: PropTypes.func
};

export default CollectionRoundCard;
